import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useContext } from "react";
import { ApiContext } from "./DistContext/DisContext";
import axios from "axios";
import toastr from "toastr";

const MyInventory = () => {
  const [addNewData, setAddNewData] = useState({
    product_name: "",
    manufacturer: "",
    product_type: "",
    description: "",
  });
  const { product_name, manufacturer, product_type, description } = addNewData;
  const { category } = useContext(ApiContext);

  const handleCancel = () => {
    setAddNewData({
      product_name: "",
      manufacturer: "",
      product_type: "",
      description: "",
    });
  };

  const addNewInventory = async () => {
    const reqbody = {
      product_name: product_name,
      manufacturer: manufacturer,
      product_type: product_type,
      description: description,
    };
    try {
      const res = await axios.post(
        `http://api.meddaily.in/request_product`,
        reqbody,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (res.status === 200) {
        toastr.success(res?.data?.message);
        setAddNewData({
          product_name: "",
          manufacturer: "",
          product_type: "",
          description: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />

          <div className="layout-page">
            <Navbar />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card">
                    <h5 className="card-header float-start">Request</h5>
                    <div className="table-responsive text-nowrap">
                      <form>
                        <div className="row">
                          <div className="col-md-6 text-start mb-3">
                            <label htmlFor="product">Product Name</label>
                            <input
                              type="text"
                              name="product"
                              id="product"
                              className="form-control"
                              placeholder="Enter product name"
                              value={product_name}
                              onChange={(e) =>
                                setAddNewData((prev) => ({
                                  ...prev,
                                  product_name: e.target.value,
                                }))
                              }
                              autoFocus
                            />
                          </div>
                          <div className="col-md-6 text-start mb-3">
                            <label htmlFor="mft">Manufacturer</label>
                            <input
                              type="text"
                              name="mft"
                              id="mft"
                              className="form-control"
                              placeholder="Mft Name"
                              value={manufacturer}
                              onChange={(e) =>
                                setAddNewData((prev) => ({
                                  ...prev,
                                  manufacturer: e.target.value,
                                }))
                              }
                            />
                          </div>
                          <div className="mb-3 col-md-6">
                            <label
                              htmlFor="medType"
                              className="form-label float-start"
                            >
                              Category
                            </label>
                            <select
                              id="medType"
                              name="productType"
                              // value={categoryId}
                              // onChange={(e) => setCategoryId(e.target.value)}
                              className="select2 form-select"
                              value={product_type}
                              onChange={(e) =>
                                setAddNewData((prev) => ({
                                  ...prev,
                                  product_type: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select</option>
                              {category &&
                                category.length > 0 &&
                                category.map((categoryItem) => (
                                  <option
                                    key={categoryItem._id}
                                    value={categoryItem._id}
                                  >
                                    {categoryItem.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-6 text-start">
                            <label htmlFor="description">Description</label>
                            <textarea
                              name="description"
                              id="description"
                              className="form-control"
                              value={description}
                              onChange={(e) =>
                                setAddNewData((prev) => ({
                                  ...prev,
                                  description: e.target.value,
                                }))
                              }
                            ></textarea>
                          </div>
                          <div className="mt-5 d-flex justify-content-center m-3 gap-5">
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={addNewInventory}
                                style={{
                                  backgroundColor: "#6eafab",
                                  border: "1px solid #6eafab",
                                }}
                              >
                                Request
                              </button>
                            </div>
                            <div>
                              <button
                                type="reset"
                                className="btn btn-outline-secondary"
                                onClick={handleCancel}
                              >
                                cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyInventory;
